import { useQueryParams } from "containers/ExecutionFilter/utils";
import { LiveUpdatesIcon } from "containers/Executions/components/LiveUpdatesIcon";
import { LogListFilter } from "containers/Resources/screens/ResourcesSingle/components/RecordLogList/LogListFilter";
import { useCallback, useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import { LogsListing } from "./LogsListing";
import { baseLogColumns } from "./columns";
import { getInitialQueryWithTableSettings } from "components/Table/tableUtils";
import { getRecordLogLevelList, initialQuery, recordLogListKey } from "./constants";
import { getIdFilter } from "./utils";

interface RecordLogListProps {
    resourceName: string;
    id: string;
    setFilterOnMount: boolean;
}

export const RecordLogList = ({ resourceName, id, setFilterOnMount }: RecordLogListProps) => {
    const history = useHistory();
    const { queryParams } = useQueryParams();
    const [queryInfo, setQueryInfo] = useState(() =>
        getInitialQueryWithTableSettings(recordLogListKey, initialQuery)
    );

    const updateQuery = useCallback(
        (newQuery: any) => {
            setQueryInfo({ ...queryInfo, ...newQuery });
        },
        [queryInfo]
    );

    const initialFilter = useMemo(() => ({ level: getRecordLogLevelList() }), []);
    const additionalQueryField = useMemo(() => getIdFilter(id), [id]);
    const [isLiveUpdatesEnabled, setLiveUpdatesEnabled] = useState(true);

    return (
        <>
            <LiveUpdatesIcon
                isLiveUpdatesEnabled={isLiveUpdatesEnabled}
                setLiveUpdatesEnabled={setLiveUpdatesEnabled}
            />
            <LogListFilter
                initialFilter={initialFilter}
                filterContext={{ recordType: resourceName, recordId: id }}
                setFilterOnMount={setFilterOnMount}
                history={history}
                queryParams={queryParams}
                isDisabled={!isLiveUpdatesEnabled}
            />
            <LogsListing
                resourceName={resourceName}
                id={id}
                additionalQueryField={additionalQueryField}
                queryInfo={queryInfo}
                updateQuery={updateQuery}
                columns={baseLogColumns}
                history={history}
                queryParams={queryParams}
                isLiveUpdatesEnabled={isLiveUpdatesEnabled}
                tableSettingsKey={recordLogListKey}
            />
        </>
    );
};
